import { Component, OnInit } from '@angular/core';
import {SharedService} from '../../../services/shared.service';
import {ICellEditorAngularComp} from 'ag-grid-angular';
import {StorageService} from '../../../services/storage.service';
import {
  logExperimentalWarnings
} from '@angular-devkit/build-angular/src/builders/browser-esbuild/experimental-warnings';

@Component({
  selector: 'app-cell-editor-type',
  templateUrl: './cell-editor-type.component.html',
  styleUrls: ['./cell-editor-type.component.scss']
})
export class CellEditorTypeComponent implements ICellEditorAngularComp, OnInit {
  private params: any;
  public types: any[] = [];
  public selected: any = {};

  constructor(
    private storageService: StorageService
  ) {
    // this.types = storageService.types;
    const nullType = storageService.types.filter(b => b.name === 'NULL');
    const othersTypes = storageService.types.filter(b => b.name !== 'NULL');
    this.types = nullType.concat(othersTypes);
  }

  ngOnInit(): void {
  }

  agInit(params: any): void {
    this.params = params;
    if (params.value) {
      this.selected = params.value;
    }
    // console.log('CellEditorBrandComponent agInit', params);
  }

  getValue(): any {
    // console.log('-----this.params', this.params);
    // this.params.data.type_name = this.types.find(type => type.id === this.selected).name;
    return this.selected;
  }

  changeType(event: any): void {
    // console.log('changeType', this.selected);
    this.selected = this.types.find(type => type._id === event.value);
    this.params.api.stopEditing();
  }
}
